export const zones = [
    {
        "zone_id": "2679",
        "country_id": "175",
        "name": "Alba",
        "code": "AB",
        "status": "1"
    },
    {
        "zone_id": "2680",
        "country_id": "175",
        "name": "Arad",
        "code": "AR",
        "status": "1"
    },
    {
        "zone_id": "2681",
        "country_id": "175",
        "name": "Arges",
        "code": "AG",
        "status": "1"
    },
    {
        "zone_id": "2682",
        "country_id": "175",
        "name": "Bacau",
        "code": "BC",
        "status": "1"
    },
    {
        "zone_id": "2683",
        "country_id": "175",
        "name": "Bihor",
        "code": "BH",
        "status": "1"
    },
    {
        "zone_id": "2684",
        "country_id": "175",
        "name": "Bistrita-Nasaud",
        "code": "BN",
        "status": "1"
    },
    {
        "zone_id": "2685",
        "country_id": "175",
        "name": "Botosani",
        "code": "BT",
        "status": "1"
    },
    {
        "zone_id": "2687",
        "country_id": "175",
        "name": "Braila",
        "code": "BR",
        "status": "1"
    },
    {
        "zone_id": "2686",
        "country_id": "175",
        "name": "Brasov",
        "code": "BV",
        "status": "1"
    },
    {
        "zone_id": "2688",
        "country_id": "175",
        "name": "Bucuresti",
        "code": "B",
        "status": "1"
    },
    {
        "zone_id": "2689",
        "country_id": "175",
        "name": "Buzau",
        "code": "BZ",
        "status": "1"
    },
    {
        "zone_id": "2691",
        "country_id": "175",
        "name": "Calarasi",
        "code": "CL",
        "status": "1"
    },
    {
        "zone_id": "2690",
        "country_id": "175",
        "name": "Caras-Severin",
        "code": "CS",
        "status": "1"
    },
    {
        "zone_id": "2692",
        "country_id": "175",
        "name": "Cluj",
        "code": "CJ",
        "status": "1"
    },
    {
        "zone_id": "2693",
        "country_id": "175",
        "name": "Constanta",
        "code": "CT",
        "status": "1"
    },
    {
        "zone_id": "2694",
        "country_id": "175",
        "name": "Covasna",
        "code": "CV",
        "status": "1"
    },
    {
        "zone_id": "2695",
        "country_id": "175",
        "name": "Dimbovita",
        "code": "DB",
        "status": "1"
    },
    {
        "zone_id": "2696",
        "country_id": "175",
        "name": "Dolj",
        "code": "DJ",
        "status": "1"
    },
    {
        "zone_id": "2697",
        "country_id": "175",
        "name": "Galati",
        "code": "GL",
        "status": "1"
    },
    {
        "zone_id": "2698",
        "country_id": "175",
        "name": "Giurgiu",
        "code": "GR",
        "status": "1"
    },
    {
        "zone_id": "2699",
        "country_id": "175",
        "name": "Gorj",
        "code": "GJ",
        "status": "1"
    },
    {
        "zone_id": "2700",
        "country_id": "175",
        "name": "Harghita",
        "code": "HR",
        "status": "1"
    },
    {
        "zone_id": "2701",
        "country_id": "175",
        "name": "Hunedoara",
        "code": "HD",
        "status": "1"
    },
    {
        "zone_id": "2702",
        "country_id": "175",
        "name": "Ialomita",
        "code": "IL",
        "status": "1"
    },
    {
        "zone_id": "2703",
        "country_id": "175",
        "name": "Iasi",
        "code": "IS",
        "status": "1"
    },
    {
        "zone_id": "2704",
        "country_id": "175",
        "name": "Ilfov",
        "code": "IF",
        "status": "1"
    },
    {
        "zone_id": "2705",
        "country_id": "175",
        "name": "Maramures",
        "code": "MM",
        "status": "1"
    },
    {
        "zone_id": "2706",
        "country_id": "175",
        "name": "Mehedinti",
        "code": "MH",
        "status": "1"
    },
    {
        "zone_id": "2707",
        "country_id": "175",
        "name": "Mures",
        "code": "MS",
        "status": "1"
    },
    {
        "zone_id": "2708",
        "country_id": "175",
        "name": "Neamt",
        "code": "NT",
        "status": "1"
    },
    {
        "zone_id": "2709",
        "country_id": "175",
        "name": "Olt",
        "code": "OT",
        "status": "1"
    },
    {
        "zone_id": "2710",
        "country_id": "175",
        "name": "Prahova",
        "code": "PH",
        "status": "1"
    },
    {
        "zone_id": "2712",
        "country_id": "175",
        "name": "Salaj",
        "code": "SJ",
        "status": "1"
    },
    {
        "zone_id": "2711",
        "country_id": "175",
        "name": "Satu-Mare",
        "code": "SM",
        "status": "1"
    },
    {
        "zone_id": "2713",
        "country_id": "175",
        "name": "Sibiu",
        "code": "SB",
        "status": "1"
    },
    {
        "zone_id": "2714",
        "country_id": "175",
        "name": "Suceava",
        "code": "SV",
        "status": "1"
    },
    {
        "zone_id": "2715",
        "country_id": "175",
        "name": "Teleorman",
        "code": "TR",
        "status": "1"
    },
    {
        "zone_id": "2716",
        "country_id": "175",
        "name": "Timis",
        "code": "TM",
        "status": "1"
    },
    {
        "zone_id": "2717",
        "country_id": "175",
        "name": "Tulcea",
        "code": "TL",
        "status": "1"
    },
    {
        "zone_id": "2719",
        "country_id": "175",
        "name": "Valcea",
        "code": "VL",
        "status": "1"
    },
    {
        "zone_id": "2718",
        "country_id": "175",
        "name": "Vaslui",
        "code": "VS",
        "status": "1"
    },
    {
        "zone_id": "2720",
        "country_id": "175",
        "name": "Vrancea",
        "code": "VN",
        "status": "1"
    }
]